import { render } from "./AddEditItemModal.vue?vue&type=template&id=4cb6b069&scoped=true"
import script from "./AddEditItemModal.vue?vue&type=script&lang=js"
export * from "./AddEditItemModal.vue?vue&type=script&lang=js"

import "./AddEditItemModal.vue?vue&type=style&index=0&id=4cb6b069&lang=less&scoped=true"

import exportComponent from "C:\\REPOS\\pos-web-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cb6b069"]])

export default __exports__